import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const saveMessages = async (formCode, form) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.deliverycoordinationsetting/updatemsj-coordination-setting': {
                    formCode: formCode,
                    form: form
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}